import { render } from "./PlantList.vue?vue&type=template&id=713f46d6"
import script from "./PlantList.vue?vue&type=script&lang=js"
export * from "./PlantList.vue?vue&type=script&lang=js"
script.render = render

export default script